import { PERSISTENCE_STATE_KEYS } from "@/other/constants/PersistenceStateKeys";
import type { GuideStatus, GuideUserPreferences } from "./types";

type GuideStatusMap = Record<string, GuideStatus>;

const STORAGE_KEY = PERSISTENCE_STATE_KEYS.pageGuidesCompleted;

function parseGuideStatusMap(raw: string | undefined): GuideStatusMap {
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return {};
    return parsed as GuideStatusMap;
  } catch {
    return {};
  }
}

export function getGuideStatus(
  userPreferences: GuideUserPreferences | null | undefined,
  guideId: string,
): GuideStatus | null {
  if (!userPreferences) return null;
  const map = parseGuideStatusMap(userPreferences.getSetting(STORAGE_KEY, "{}"));
  return map[guideId] ?? null;
}

export function setGuideStatus(
  userPreferences: GuideUserPreferences | null | undefined,
  guideId: string,
  status: GuideStatus,
): void {
  if (!userPreferences) return;
  const map = parseGuideStatusMap(userPreferences.getSetting(STORAGE_KEY, "{}"));
  map[guideId] = status;
  userPreferences.updateSetting(STORAGE_KEY, JSON.stringify(map));
}
